module.exports = __webpack_public_path__ + "vi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/vi.svg
// module id = 881
// module chunks = 0